import { FC, ReactElement } from 'react';
// @ts-ignore
import LazyLoad from 'react-lazy-load';
import isPrerender from '../../utils/is-prerender';
import isUITest from '../../utils/is-ui-test';

type LmpLazyProps = {
    content: ReactElement;
    className?: string;
    debounce?: boolean;
    height?: number;
    immediately?: boolean;
    offset?: number;
    width?: number;
    onContentVisible?: (value: number) => void;
};

const LmpLazy: FC<LmpLazyProps> = (props) => {
    const { content, offset, debounce, immediately, ...rest } = props;
    const noLazy = immediately || isPrerender() || isUITest();

    return (
        <>
            {noLazy ? (
                <>{content}</>
            ) : (
                // @ts-ignore
                <LazyLoad debounce={Boolean(debounce)} offset={offset || 500} {...rest}>
                    <>{content}</>
                </LazyLoad>
            )}
        </>
    );
};

export default LmpLazy;
